/**
 * Section B4 Service
 * B.4.基準線情境 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/section-b4';

export interface SectionB4Detail {
  id: number;
  organization_id: number;
  project_id: number;
  baseline_scenario: string | null;
  baseline_equipment: string | null;
  baseline_procedure: string | null;
  future_demand: string | null;
  bau_scenario: string | null;
  bau_procedure: string | null;
  b_4: number;
  edit_by: number | null;
  created_at: string;
  updated_at: string | null;
}

export interface SectionB4Update {
  baseline_scenario?: string;
  baseline_equipment?: string;
  baseline_procedure?: string;
  future_demand?: string;
  bau_scenario?: string;
  bau_procedure?: string;
}

export const getSectionB4ByProject = async (projectId: number): Promise<SectionB4Detail | null> => {
  const response = await axios.get<SectionB4Detail>(`${BASE_URL}/by-project/${projectId}`);
  return response.data;
};

export const updateSectionB4 = async (projectId: number, data: SectionB4Update): Promise<SectionB4Detail> => {
  const response = await axios.put<SectionB4Detail>(`${BASE_URL}/${projectId}`, data);
  return response.data;
};

export const deleteSectionB4 = async (projectId: number): Promise<void> => {
  await axios.delete(`${BASE_URL}/${projectId}`);
};

const sectionB4Service = { getSectionB4ByProject, updateSectionB4, deleteSectionB4 };
export default sectionB4Service;
